var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-link"},[(_vm.to)?[(_vm.$fun.ifHttpUrl(_vm.to) || _vm.blank)?_c('a',{staticClass:"m-link-a",attrs:{"href":_vm.to,"target":_vm.blank ? '_blank' : ''}},[_vm._t("default")],2):_c('router-link',{staticClass:"m-link-a",attrs:{"to":_vm.to}},[_vm._t("default")],2)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }